/**
 * Course session recordings.
 */
import React from "react";
import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { BEmpty, BGPagination } from "components";
import { useAsterController } from "context";
import { actionPastSessionList } from "context/action";
import { VText } from "form";
import CourseReplayItem from "./course.replay.item";

/**
 * Lists recorded live sessions for replay.
 */
const CourseReplay = () => {
  const { t } = useTranslation("common");

  const { courseId } = useParams();

  const [controller, dispatch] = useAsterController();
  const { pastSessions } = controller;

  const handlePageChange = (page, pageSize) => actionPastSessionList(dispatch, { course_id: courseId, page, page_size: pageSize });

  return (
    <>
      <Box>
        <Box className="w-full flex justify-center sm:justify-start">
          <VText className="text-2xl font-bold">{t("Your Replay")}</VText>
        </Box>
        {
          pastSessions.data?.length ? (
            <Box className="w-full my-5">
              <Grid container spacing={3}>
                {(pastSessions.data || []).map((session, idx) => (
                  <Grid key={`${session.id || session.file_id || session.room}-${idx}`} item xs={12} sm={6} lg={4}>
                    <CourseReplayItem session={session} />
                  </Grid>
                ))}
                <Grid item xs={12}>
                  <BGPagination handlePageChange={handlePageChange} total={pastSessions.total} initPage={pastSessions.page} initSize={pastSessions.page_size} />
                </Grid>
              </Grid>
            </Box>
          )
          :
          <BEmpty />
        }
      </Box>
    </>
  );
};

export default CourseReplay;
